/*globals $:false */

import AdvancedSearchM from './model/recordm.model.advancedsearch.js';
import { DEV_MODE } from '@cob/ui-genesis/helpers/cob.devmode.js';
import DefinitionM from './model/recordm.model.entity.definition.js';
import DefinitionSearchResultP from './presenter/recordm.presenter.searchresult.definition.js';
import InstanceActions from './actions/recordm.actions.instance.js';
import MultipleSearchP from './presenter/recordm.presenter.multiplesearch.js';
import SearchVisGroupM from './model/recordm.model.searchvisgroup.js';
import SimpleSearchM from './model/recordm.model.simplesearch.js';

import { sprintf } from 'sprintf-js';

import tmpl from './templates/search-definition.dot';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

var SearchDefinition = function(core) {

    var _$mainContainer,
        _running = false;

    var _searchP,
        _searchResultP;

    var _instanceActions;

    var _viewId,
        _views;

    var _definitionId,
        _searchMode,
        _searchQuery;

    var _definitionM;

    var _onDefinitionUpdated = function(e, data) {
        _definitionM = core.getModels(DefinitionM.entityKey + ":" + data.id);

        // update the breadcrumbs if the domain has changed name.
        core.publish("modules:stack-description-updated");
    };

    // update the definition in the model repo with the latest version
    var _loadDefinition = function(definitionId, loadLatch) {
        DefinitionM.get(core, definitionId, {
            forceReload: true,

            success: function(definitionM) {
                _definitionM = definitionM;
                DEV_MODE && window.console.log("definition:loaded:" + _definitionM.data.id);

                core.subscribe(_definitionM.update_event_name, _onDefinitionUpdated);
                core.publish("modules:stack-description-updated");

                loadLatch.countDown("definition:loaded:" + _definitionM.data.id);
            },

            error: function(status) {
                if (status === 404) {
                    ui.notification.showCustom(
                        'error',
                        sprintf(core.translateString("recordm.definition", "definition.msg.error-title"), definitionId),
                        core.translateString("recordm.definition", "definition.msg.not-found")
                    );
                }
            }
        });
    };

    // load all _views associated with this definition
    var _loadDefinitionViews = function(settingKey, loadLatch) {
        SearchVisGroupM.loadAll(core, settingKey, function(views) {
            _views = views;
            loadLatch.countDown("User definition _views loaded");
        });
    };

    // Perform several requests to the server that are
    // necessary through this module
    var _loadDependencies = function(definitionId, onDone) {

        var dependenciesLoadLatch = new utils.CountdownLatch(2, onDone);

        // Want the process of loading the dependencies to be "parallel"
        // instead of beeing one after another

        // Load the Definition associated to this definitionId
        _loadDefinition(definitionId, dependenciesLoadLatch);

        // Load the user definition _views
        _loadDefinitionViews(
            new DefinitionM(core, {id: definitionId}).getSettingKey(),
            dependenciesLoadLatch
        );
    };

    var _init = function(definitionId, searchMode, searchQuery, activeVisualizationId, filters) {
        _running = true;

        _definitionId = definitionId;
        _searchQuery = searchQuery;
        _searchMode = searchMode;
        _viewId = activeVisualizationId !== "undefined" ? parseInt(activeVisualizationId, 10) : undefined;

        _loadDependencies(definitionId, function() {

            var _visualizationGroupM = new SearchVisGroupM(core, _definitionM, _views),
                _simpleSearchM,
                _advSearchM,
                _searchM;

            _advSearchM = new AdvancedSearchM(core,
                "recordm/definitions/search/advanced/" + definitionId,
                "recordm/definitions/search/download/advanced/" + definitionId,
                "recordm/definitions/search/download/" + definitionId
            );

            _simpleSearchM = new SimpleSearchM(
                core,
                "recordm/definitions/search/" + definitionId,
                "recordm/definitions/search/download/" + definitionId
            );

            const definitionFilters = JSON.parse(JSON.stringify(core.getCustomDefinitionSearchFilters(_definitionM.data.name)))
            definitionFilters.forEach(f => f.defaultValue = f.selected)

            if (filters && filters !== "undefined") {
                if (filters && !filters.startsWith("{")) {
                  // in case the fragment has been encoded by AuthM we decode it first.
                  filters = decodeURIComponent(filters);
                }

                const filtersObj = JSON.parse(filters);

                definitionFilters.forEach(function(f) {
                    // if the definition has filters then we start to set them all to false to ensure
                    // that bookmarked urls continue to work even after new filters are added
                    f.selected = false

                    // then only check to true the filters that are present in the url
                    if (filtersObj[f.label] !== undefined) {
                        f.selected = filtersObj[f.label]
                    }
                })
            }
            _simpleSearchM.setFilters(definitionFilters)

            _$mainContainer = $(tmpl());
            if(_running) _$mainContainer.appendTo('#'+core.getAppInstanceId());
            _$mainContainer.removeClass("hidden");

            if (searchMode === 'aq') {
                try {
                    _searchQuery = JSON.parse(searchQuery || []);
                } catch (e) {
                    // if there's malformed json in the url don't error out.
                    _searchQuery = [];
                }

                _searchM = _advSearchM;
            } else {
                _searchM = _simpleSearchM;
            }

            _searchP = MultipleSearchP(
                core,
                undefined,
                $(".js-search-container", _$mainContainer),
                _definitionM,
                _simpleSearchM,
                _advSearchM,
                _visualizationGroupM
            );

            _instanceActions = new InstanceActions(core);

            _searchResultP = new DefinitionSearchResultP(
                core,
                _searchM,
                _definitionM,
                _visualizationGroupM,
                _instanceActions,
                $(".js-results-container", _$mainContainer),
                { moduleBaseUri: "/definitions/" + definitionId }
            );
            _searchResultP.init(searchQuery, _viewId);

            _searchP.init(_searchQuery, _viewId);
            _searchP.prepareView();
        });
    };

    var _resume = function() {
        _running = true;
        if (_definitionM) {
            _$mainContainer.appendTo('#'+core.getAppInstanceId());

            _searchP.resume();
            _searchResultP.resume();

            _searchP.prepareView();
            _searchResultP.prepareView();
        }
    };

    var _pause = function() {
        _running = false;
        if (_definitionM) {
            _searchP.pause();
            _searchResultP.pause();

            _$mainContainer.detach();
        }
    };

    var _destroy = function() {
        _running = false;
        if (_definitionM) {
            _searchP.destroy();
            _searchResultP.destroy();

            _$mainContainer.remove();

            core.unsubscribe(_definitionM.update_event_name, _onDefinitionUpdated);
            _definitionM.release();
        }
    };

    return {
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,

        getDescription: function() {
            if (_definitionM) {
                return {
                    definition: {
                        id:_definitionM.data.id,
                        name: _definitionM.data.name,
                        description: _definitionM.data.description
                    }
                }

            } else {
                return {
                    definition: {
                        id:_definitionId
                    }
                }
            }
        }
    }
};

export default SearchDefinition;
